import type { CoreCharacter, ExpressionTopic, RefinementResult } from "../shared/refinement";

export type NarrativeLayer = "history" | "legend" | "game";
export type BambooStyle = "wind" | "rain" | "sparse" | "dense";
export type ArtView = "painting" | "character" | "meaning";

export interface GameState {
  screen: number;
  firstChoice: string;
  firstCustom: string;
  leaveDecision: "leave" | "repay" | "";
  artifactsPlaced: string[];
  puzzleStage: number;
  topic: ExpressionTopic | "";
  originalInput: string;
  privacyMode: boolean;
  refinement: RefinementResult | null;
  selectedPhrase: string;
  coreCharacter: CoreCharacter;
  bambooStyle: BambooStyle;
  artView: ArtView;
  hiddenName: string;
  nameArtView: ArtView;
}

export const INITIAL_STATE: GameState = {
  screen: 0,
  firstChoice: "",
  firstCustom: "",
  leaveDecision: "",
  artifactsPlaced: [],
  puzzleStage: 0,
  topic: "",
  originalInput: "",
  privacyMode: false,
  refinement: null,
  selectedPhrase: "",
  coreCharacter: "信",
  bambooStyle: "wind",
  artView: "painting",
  hiddenName: "",
  nameArtView: "painting",
};
